import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {DictInfo} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';

import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';


@Component({
  selector: 'app-registry-passport-info',
  templateUrl: './passportInfo.component.html'
})
export class PassportInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  defaultParam = {pageSize: 20, sort: 'uploaded', dir: 'DESC'};
  isSearchResult = false;
  searchResult: string;
  resultValue: boolean;
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly resourceSrv: ResourceService,
              private readonly userSrv: UserService,
              private readonly alertSrv: AlertService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'uploaded', dir: 'DESC'});
  }

  passportInfoEntries: Array<DictInfo> = [];
  private access: AccessJson; //

  ngOnInit(): void {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_PASSP);
    const queryParams = this.getParams(this.defaultParam);
    this.loadPassportInfo(queryParams);
    this.activatedRoute.queryParams.subscribe(data => {
      const syncParams= this.syncParams(data);
      if (syncParams.number && syncParams.series) {
        this.loadList(syncParams);
      } else if(Object.keys(syncParams).length > 0){
        this.loadPassportInfo(syncParams);
      } else {
        this.isSearchResult = false;
      }
    });
  }

  loadList(params?: any): void {
    const queryParams = this.getParams(params);
    this.regSrv.getPassportSubjectList(queryParams).subscribe((data: boolean) => {
      this.isSearchResult = true;
      this.searchResult = this.getSearchResult(data);
      this.resultValue = data;
    });
  }

  loadPassportInfo(queryParams?: object): void {
    this.resourceSrv.getPassportInfo(queryParams).subscribe(data => {
      this.passportInfoEntries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  getSearchResult(result: boolean): string {
    return result
      ? 'Указанный паспорт РФ числится в списке недействительных российских паспортов.'
      : 'Соответствий не выявлено.';
  }

   onPageChange(params): void {
    this.navigate({...params, ...this.getParams(this.filter)});
  }

   onSearch(): void {
    const params = this.getSearchPage(this.filter);
    const queryParams = this.getFilterObject(params);
    queryParams["dir"] = "ASC";
    queryParams["sort"] = "series";
    this.tableService.saveScrollPosition(this.commonKeyStore);
  }

   remove(confirm, passport: DictInfo): void {
    this.alertSrv.clear();
    this.regSrv.removeFile('/api/v1/qref/passport/remove', {id: passport.id}).subscribe(data => {
      this.alertSrv.success(`Запись ${passport.name} удалена!`);
      this.loadPassportInfo();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
   checkRiskFactor(item: DictInfo): void {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.PASSPORT, this.loadCheckList, this.alertObjToCheck);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
   getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  /**
   * Метод проверки доступа
   */
   checkAccess(): boolean {
    return this.access.readOnly;
  }

  ngOnDestroy(): void {
    this.checkScrollOptions();
  }

}
